import React from 'react';
import cn from 'classnames';
import { Loader } from '@progress/kendo-react-indicators';
import './style.scss';

const LoaderSpinner = ({ className, ...props }) => {
  const loaderClassName = cn('loader-spinner', { [className]: className });
  return (
    <Loader
      type="converging-spinner"
      className={loaderClassName}
      {...props}
    />
  );
};

export default LoaderSpinner;
